import { get } from 'axios'
import { zip } from 'lodash'

const ANNOUNCEMENT_URL = process.env.BASE_URL + 'announcement'
const ANNOUNCEMENT_INDEX_URL = ANNOUNCEMENT_URL + '/index.txt'

const development = process.env.NODE_ENV === 'development'

const storage = development ? sessionStorage : localStorage

const ANNOUNCEMENT_LAST_READ_KEY = development
  ? 'DEV_GIGGLE_ANNOUNCEMENT_LAST_READ'
  : 'GIGGLE_ANNOUNCEMENT_LAST_READ'

/**
 * お知らせ
 */
export default {
  /**
   * お知らせ一覧の取得
   *
   * 環境変数`${ANNOUNCEMENT_URL}/index.txt`列挙されているお知らせIDを参照し、
   * `${ANNOUNCEMENT_URL}/${お知らせID}.txt`からお知らせ内容を取得します。
   *
   * 例）
   *
   * index.txt
   *
   * ```
   * 20190101_1
   * 20190131_1
   * 20190131_2
   * ```
   *
   * 20190101_1.txt
   *
   * ```
   * お知らせ内容のテキスト、、、、、
   * ```
   */
  async get() {
    const data = await get(ANNOUNCEMENT_INDEX_URL).then(r => r.data)
    const dates = data
      .split('\n')
      .map(v => v.trim())
      .filter(v => v)
      .reverse()

    if (dates.length === 0) {
      return []
    }

    const promises = dates.map(date => get(`${ANNOUNCEMENT_URL}/${date}.txt`))
    const bodies = (await Promise.all(promises))
      .map(r => r.data)
      .map(content => content.trim())

    return zip(dates, bodies).map(([date, body]) => ({
      id: date,
      date: date.slice(0, 8),
      body,
    }))
  },
  getLastRead() {
    return Promise.resolve(storage.getItem(ANNOUNCEMENT_LAST_READ_KEY))
  },
  postLastRead(id) {
    storage.setItem(ANNOUNCEMENT_LAST_READ_KEY, id)
    return Promise.resolve()
  },
}
